/**
 * This file describes stacking of elements in graph.
 * All used zIndexes should be controlled from there to keep overall control over stacking
 * and prevent glitches by multiple plugins controlling the stacking.
 */

export const ZINDEX_BOX_BASE = 0;
export const ZINDEX_EDGE = 1;
export const ZINDEX_NODE_DRAG_CURTAIN = 2;
/**
 * Boxes are usually rendered behind edges, but during drag, edges are hidden by curtain
 * while boxes have to remain visible.
 */
export const ZINDEX_BOX_DRAG = 3;
export const ZINDEX_DROP_PREVIEW_NODE = 4;
export const ZINDEX_MATCH_HIGHLIGHT_AREA = 4;
export const ZINDEX_NODE = 5;
export const ZINDEX_HIGHLIGHT_CURTAIN = 6;
export const ZINDEX_EDGE_HIGHLIGHTED = 7;
export const ZINDEX_NODE_HIGHLIGHTED = 8;
export const ZINDEX_EDGE_HIGHLIGHT_AREA = 9;
export const ZINDEX_HOVERED_NODE_HIGHLIGHTED = 10;
export const ZINDEX_HOVERED_EDGE_HIGHLIGHTED = 11;

// zIndexes in edge container
export const ZINDEX_EDGE_LINE = 0;
export const ZINDEX_EDGE_HIGHLIGHT_LINE = 1;
export const ZINDEX_EDGE_LABELS = 2;
